module.exports = __webpack_public_path__ + "static/media/vandercook2.16759b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vandercook2.jpg
// module id = 89
// module chunks = 0